import { useEffect, useState } from 'react';
import AnimatedNumber from 'react-animated-number';
import Image from '../../../components/image/Image';
import LoaderBar from '../../../components/loader-bar/LoaderBar';
import { ContentTitle } from '../../../components/typography/Heading';
import { formatMoneyKr, formatNumber } from '../../../utils';
import styles from './live-data.module.less';
import { fetchData } from './live-data-tva-actions';

const LiveDataTva = () => {
    const [givereTotalt, setGivereTotalt] = useState();
    const [sisteTimeBelop, setSisteTimeBelop] = useState();
    const [sisteTimeAntall, setSisteTimeAntall] = useState();
    const [antallKladder, setAntallKladder] = useState();
    const [bosserTotalt, setBosserTotalt] = useState();
    const [belopTotalt, setBelopTotalt] = useState();
    const [elementInList, setElementInList] = useState(0);

    const [error, setError] = useState(false);
    const [loading, setLoading] = useState(false);

    const fetchNewData = () => {
        fetchData()
            .then((data) => {
                const antallBosser = data.values.find((v) => v[0] === 'bosser_antall');
                const bosserKladd = data.values.find((v) => v[0] === 'bosser_kladd');
                const sisteTime = data.values.find((v) => v[0] === 'givere_siste_time');
                const totalt = data.values.find((v) => v[0] === 'givere_totalt');
                const innsamet = data.values.find((v) => v[0] === 'innsamlet_totalt');
                setError(false);
                setElementInList(0);
                setBosserTotalt(antallBosser[1]);
                setAntallKladder(bosserKladd[1]);
                setSisteTimeAntall(sisteTime[1]);
                setSisteTimeBelop(sisteTime[2]);
                setGivereTotalt(totalt[1]);
                setBelopTotalt(innsamet[1]);
            })
            .catch(() => {
                setError(true);
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        setLoading(true);
        fetchNewData();
    }, []);

    useEffect(() => {
        const timer = setInterval(fetchNewData, 30 * 1000);
        return () => clearInterval(timer);
    }, []);

    if (error) {
        return null;
    }

    if (loading) {
        return <LoaderBar />;
    }

    return (
        <div className={styles.container}>
            <ContentTitle>Aktivitet</ContentTitle>
            <div className={styles.numberWrapper}>
                <div className={styles.numberContainer}>
                    <div className={styles.numberTitleWrapper}>
                        <Image className={styles.icon} src={'campaign/tva2025/digital_bosse.svg'} />
                        <AnimatedNumber
                            duration={3000}
                            className={styles.numberTitle}
                            value={antallKladder?.[elementInList]}
                            formatValue={formatNumber}
                        />
                    </div>
                    <span className={styles.numberDescription}>lager bøsse nå</span>
                    <span className={styles.summary}>
                        Totalt{' '}
                        <AnimatedNumber
                            duration={3000}
                            className={styles.bold}
                            value={bosserTotalt?.[elementInList]}
                            formatValue={formatNumber}
                        />{' '}
                        bøsser
                    </span>
                </div>
                <div className={styles.numberContainer}>
                    <div className={styles.numberTitleWrapper}>
                        <Image className={styles.icon} src={'feature-illustrations/hånd-hjerte-blå-mørkere.svg'} />
                        <AnimatedNumber
                            duration={3000}
                            className={styles.numberTitle}
                            value={sisteTimeAntall?.[elementInList]}
                            formatValue={formatNumber}
                        />
                    </div>
                    <span className={styles.numberDescription}>givere siste timen</span>
                    <span className={styles.summary}>
                        Totalt{' '}
                        <AnimatedNumber
                            duration={3000}
                            className={styles.bold}
                            value={givereTotalt?.[elementInList]}
                            formatValue={formatNumber}
                        />{' '}
                        givere
                    </span>
                </div>

                <div className={styles.numberContainer}>
                    <div className={styles.numberTitleWrapper}>
                        <Image className={styles.icon} src={'campaign/tva2025/pengesekk.svg'} />
                        <AnimatedNumber
                            duration={3000}
                            className={styles.numberTitle}
                            value={sisteTimeBelop?.[elementInList]}
                            formatValue={formatMoneyKr}
                        />
                    </div>
                    <span className={styles.numberDescription}>samlet inn siste timen</span>
                    <span className={styles.summary}>
                        Totalt{' '}
                        <AnimatedNumber
                            duration={3000}
                            className={styles.bold}
                            value={belopTotalt?.[elementInList]}
                            formatValue={formatNumber}
                        />{' '}
                        innsamlet
                    </span>
                </div>
            </div>
        </div>
    );
};

export default LiveDataTva;
